import React from 'react';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { useEnquiry } from '../../contexts/EnquiryContext';
import { contact } from '../../data/site';
import { AustraliaDotMap } from '../AustraliaDotMap';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
export function DemoTour() {
  const {
    startEnquiry
  } = useEnquiry();
  return <section id="demo-tour" aria-labelledby="demo-title" className="bg-white" data-id="element-224" data-mp="3gcog32xvmmpl">
      <div className="mx-auto grid max-w-page items-center gap-14 px-5 py-20 lg:grid-cols-[0.9fr_1.1fr] lg:px-8 lg:py-28" data-id="element-225" data-mp="3gerfueotzu7i">
        <Reveal data-id="element-226" data-mp="36mv789p4clp1">
          <h2 id="demo-title" className="font-sora text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] md:text-[2.75rem]" data-id="element-227" data-mp="36mbzflt6ndoq">
            See it running before you commit.
          </h2>
          <p className="mt-5 max-w-lg text-lg leading-relaxed text-afb-muted" data-id="element-228" data-mp="2xkvnh9mpz3ie">
            Book a demo tour at our base in Bibra Lake, Perth. Walk around the system, see how it’s set up and run,
            and ask the people who’ll design yours.
          </p>

          <div className="mt-8 flex items-start gap-3 text-[15px]" data-id="element-229" data-mp="orc27bjkyjpb">
            <MapPinIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-afb-teal" data-id="element-230" data-mp="otot4e7bg4ei" />
            <p className="text-afb-ink" data-id="element-231" data-mp="ay48nebxve4z">
              {contact.street}, {contact.locality} {contact.region} {contact.postcode}
              <span className="block text-afb-muted" data-id="element-232" data-mp="12rmrwb95ls8w">We’ll confirm a time within 48 hours.</span>
            </p>
          </div>

          <div className="mt-8" data-id="element-233" data-mp="17pevi2j5v2sx">
            <Button variant="ink" onClick={() => startEnquiry({
            intent: 'demo-tour'
          })} data-id="element-234" data-mp="17polvr84bbz5">
              Book a demo tour
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-235" data-mp="tt1awkjbyla8" />
            </Button>
          </div>
        </Reveal>

        <Reveal delay={60} data-id="element-236" data-mp="3egecgxp80kw7">
          <AustraliaDotMap data-id="element-237" data-mp="3eg4k53gpe1nc" />
          <p className="mt-4 text-center text-sm text-afb-muted" data-id="element-238" data-mp="3ej0j8v4aewdd">From Bibra Lake to wherever you need power, Australia-wide.</p>
        </Reveal>
      </div>
    </section>;
}